import { isMobile } from 'lib/device'
import useStore from 'state/knovStore'
import {
    isInlineMediaPlaybackHandoffPending,
    isMediaElementPlaybackHandoffSource,
    prepareActiveMediaPlaybackForInlineHandoff,
    resumePendingInlineMediaPlayback,
    stopActiveMediaPlayback,
} from 'state/mediaPlaybackCoordinator'
import { getLeavingPanelIndicesForSlide } from 'components/panels/panelMediaPlaybackPolicy'

const PANEL_MEDIA_CONTAINER_SELECTOR = '[data-panel-media-container="true"]'

export function pausePanelMedia(container, { dockOnRelease = true } = {}) {
    if (!container) return

    stopActiveMediaPlayback({ scopeElement: container, dockOnRelease })

    container.querySelectorAll('audio, video').forEach(mediaEl => {
        // Never silence the element an in-flight handoff keeps sounding.
        if (isMediaElementPlaybackHandoffSource(mediaEl)) return
        if (typeof mediaEl.pause === 'function' && !mediaEl.paused) {
            mediaEl.pause()
        }
    })
}

export function findPanelMediaContainerByPanelId(panelId) {
    if (!panelId || typeof document === 'undefined') return null

    return (
        Array.from(document.querySelectorAll(PANEL_MEDIA_CONTAINER_SELECTOR)).find(
            element => element.getAttribute('data-panel-media-panel-id') === String(panelId),
        ) || null
    )
}

export function pausePanelMediaByPanelId(panelId, options) {
    pausePanelMedia(findPanelMediaContainerByPanelId(panelId), options)
}

export function preparePanelMediaHandoffToAnswer(panelId, answerId) {
    const container = findPanelMediaContainerByPanelId(panelId)
    if (!container) return null

    return prepareActiveMediaPlaybackForInlineHandoff(answerId, { scopeElement: container })
}

export function resumePanelMediaHandoff(panelId, mediaKey, attempt = 0) {
    if (!panelId || !mediaKey || attempt >= 100) return
    if (!isInlineMediaPlaybackHandoffPending(mediaKey)) return

    const container = findPanelMediaContainerByPanelId(panelId)
    if (container && resumePendingInlineMediaPlayback(mediaKey, { scopeElement: container })) {
        return
    }

    window.setTimeout(() => resumePanelMediaHandoff(panelId, mediaKey, attempt + 1), 100)
}

export function pausePanelMediaByPanelIndex(panelIndex, options) {
    if (!Number.isInteger(panelIndex)) return

    const panel = useStore.getState().panels.state[panelIndex]
    pausePanelMediaByPanelId(panel?.panelId, options)
}

export function pausePanelMediaLeavingSwiperViewport(
    previousActiveIndex,
    nextActiveIndex,
    options,
) {
    const state = useStore.getState()
    const leavingPanelIndices = getLeavingPanelIndicesForSlide(
        previousActiveIndex,
        nextActiveIndex,
        {
            mobile: isMobile,
            numPanels: state.numPanels,
            leftSidebarOpen: Boolean(state.showSidebar),
        },
    )
    leavingPanelIndices.forEach(panelIndex => pausePanelMediaByPanelIndex(panelIndex, options))
}
